import * as actionType from "../../context/actions";

const GetEarnings = async (state, dispatch, data) => {
    if (!data) return null;

    try {
        let totalEarnings = 0;
        let paidEarnings = 0;
        let unpaidEarnings = 0;

        data?.forEach(([id, info]) => {
            const items = info.items || [];
            const hasSalesReturn = items.some(
                item => item?.isSalesReturnKey === true || item?.isSalesReturnKey === "true"
            );
            const amount = parseFloat(info.totalAmount || 0);

            totalEarnings += amount;

            if (info.paidFlagKey === "true" || info.paidFlagKey === true) {
                paidEarnings += amount;
            } else {
                unpaidEarnings += amount;
            }

        });

        dispatch({ type: actionType.TOTALEARNING, payload: totalEarnings.toFixed(2) });
        dispatch({ type: actionType.TOTALPAIDEARNING, payload: paidEarnings.toFixed(2) });
        dispatch({ type: actionType.TOTALUNPAIDEARNING, payload: unpaidEarnings.toFixed(2) });

        return {
            totalEarnings: +totalEarnings.toFixed(2),
            paidEarnings: +paidEarnings.toFixed(2),
            unpaidEarnings: +unpaidEarnings.toFixed(2)
        };
    } catch (error) {
        console.error("Error calculating earnings:", error);
        return null;
    }
};

export default GetEarnings;
